import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import './Birthday2026.css';

const Birthday2026 = () => {

    const form = useRef();
    const locationLink = "https://www.google.com/maps/@43.6504205,-79.4658229,18z?entry=ttu&g_ep=EgoyMDI2MTAxMy4wIKXMDSoASAFQAw%3D%3D"
    
    const [inviteClicked, setInviteClicked] = useState(false);

    function toggleInviteClicked() {
        setInviteClicked(true);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const name = document.forms["form"]["name"].value;
        if (!name) return;

        // Send Pushover Notification to Sean
        emailjs.sendForm('service_cm2uz9c', 'template_hbf6dun', form.current, 'FKC373I6g-JjuTk3R')
            .then(() => {
                toggleInviteClicked()
            }, (error) => {
                console.log(error.text);
        });

        
    };

    return (
        <article className="birthday2026">
            <Link className="back-button" to="/">Back</Link>

            <div className="content-wrapper">

                <div className="semicircle top" />
                <div className="bar top" />

                <section>
                    <h1>Sean's 23rd Birthday Hangout</h1>
                    <p>
                        Hello! I’m doing a little birthday hangout at High Park on October 24th at 12:30pm. 
                    </p>
                    <p>
                        I'm planning to order some pizzas and chat the at <a href={locationLink}>picnic benches close to the soccer fields</a>. Feel free to come and go as you please!
                    </p>
                    <p> 
                        If you think you’ll be able to come, just put your name below so I can keep track! 
                    </p>
                    {inviteClicked ? <p>RSVP Received!</p> :
                        <form name = "form" ref={form} onSubmit={handleSubmit}>
                            <input type="text" name="name" id="name" placeholder = "Your Name" autoComplete="off" />
                            <button type='submit' value="Send">I'm down!</button>
                        </form>
                    }
                </section>

                <div className="bar bottom" />
                <div className="semicircle bottom" />

            </div>
       
        </article>
    );
    
}

export default Birthday2026;